import { render, staticRenderFns } from "./speak.vue?vue&type=template&id=6bab170d&scoped=true&"
import script from "./speak.vue?vue&type=script&lang=js&"
export * from "./speak.vue?vue&type=script&lang=js&"
import style0 from "./speak.vue?vue&type=style&index=0&id=6bab170d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bab170d",
  null
  
)

export default component.exports